var _circle, _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _g4, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g5, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 307,
    height: 307,
    viewBox: "0 0 307 307",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 153.36,
    cy: 153.36,
    r: 153.36,
    fill: "white",
    fillOpacity: 0.22
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8_6045)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.36,
    cy: 153.36,
    rx: 124.466,
    ry: 124.466,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_8_6045)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.359,
    cy: 153.36,
    rx: 96.6835,
    ry: 96.6835,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_8_6045)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 153.36,
    cy: 153.36,
    r: 66.6783,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_6045)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.783 146.221H142.402V147.439H162.783V146.221Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.354 148.246V156.158C145.354 160.085 148.577 163.27 152.552 163.27C156.526 163.27 159.749 160.085 159.749 156.158V148.246H145.354Z",
    fill: "#F4A428"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.749 145.416V137.386C159.749 133.458 156.526 130.274 152.552 130.274C148.577 130.274 145.354 133.458 145.354 137.386V145.416H159.749Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M155.057 145.416V133.2C155.057 132.18 154.735 131.235 154.185 130.459C153.66 130.338 153.115 130.272 152.552 130.272C148.577 130.272 145.354 133.456 145.354 137.384V145.414H155.057V145.416Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.553 143.514V134.378C152.553 133.13 151.582 132.055 150.321 131.997C148.974 131.935 147.861 132.994 147.861 134.312V143.514C147.861 144.283 148.493 144.905 149.269 144.905H151.143C151.922 144.905 152.551 144.281 152.551 143.514H152.553Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_6045",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 130,
    width: 15,
    height: 16
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M159.749 145.416V137.386C159.749 133.458 156.526 130.274 152.552 130.274C148.577 130.274 145.354 133.458 145.354 137.386V145.416H159.749Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_6045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.002 131.414C146.002 131.171 145.802 130.973 145.556 130.973C145.31 130.973 145.109 131.171 145.109 131.414V131.584C145.109 131.827 145.31 132.025 145.556 132.025C145.802 132.025 146.002 131.827 146.002 131.584V131.414Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.128 131.414C149.128 131.171 148.928 130.973 148.682 130.973C148.436 130.973 148.235 131.171 148.235 131.414V131.584C148.235 131.827 148.436 132.025 148.682 132.025C148.928 132.025 149.128 131.827 149.128 131.584V131.414Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.252 131.414C152.252 131.171 152.052 130.973 151.806 130.973C151.56 130.973 151.359 131.171 151.359 131.414V131.584C151.359 131.827 151.56 132.025 151.806 132.025C152.052 132.025 152.252 131.827 152.252 131.584V131.414Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.378 131.414C155.378 131.171 155.178 130.973 154.932 130.973C154.686 130.973 154.485 131.171 154.485 131.414V131.584C154.485 131.827 154.686 132.025 154.932 132.025C155.178 132.025 155.378 131.827 155.378 131.584V131.414Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.502 131.414C158.502 131.171 158.302 130.973 158.056 130.973C157.81 130.973 157.609 131.171 157.609 131.414V131.584C157.609 131.827 157.81 132.025 158.056 132.025C158.302 132.025 158.502 131.827 158.502 131.584V131.414Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.564 133.518C147.564 133.275 147.364 133.077 147.117 133.077C146.871 133.077 146.671 133.275 146.671 133.518V133.688C146.671 133.931 146.871 134.129 147.117 134.129C147.364 134.129 147.564 133.931 147.564 133.688V133.518Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.69 133.518C150.69 133.275 150.49 133.077 150.243 133.077C149.997 133.077 149.797 133.275 149.797 133.518V133.688C149.797 133.931 149.997 134.129 150.243 134.129C150.49 134.129 150.69 133.931 150.69 133.688V133.518Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.816 133.518C153.816 133.275 153.615 133.077 153.369 133.077C153.123 133.077 152.923 133.275 152.923 133.518V133.688C152.923 133.931 153.123 134.129 153.369 134.129C153.615 134.129 153.816 133.931 153.816 133.688V133.518Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.941 133.518C156.941 133.275 156.74 133.077 156.494 133.077C156.248 133.077 156.048 133.275 156.048 133.518V133.688C156.048 133.931 156.248 134.129 156.494 134.129C156.74 134.129 156.941 133.931 156.941 133.688V133.518Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.066 133.518C160.066 133.275 159.865 133.077 159.619 133.077C159.373 133.077 159.173 133.275 159.173 133.518V133.688C159.173 133.931 159.373 134.129 159.619 134.129C159.865 134.129 160.066 133.931 160.066 133.688V133.518Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.002 135.623C146.002 135.38 145.802 135.182 145.556 135.182C145.31 135.182 145.109 135.38 145.109 135.623V135.793C145.109 136.036 145.31 136.234 145.556 136.234C145.802 136.234 146.002 136.036 146.002 135.793V135.623Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.128 135.623C149.128 135.38 148.928 135.182 148.682 135.182C148.436 135.182 148.235 135.38 148.235 135.623V135.793C148.235 136.036 148.436 136.234 148.682 136.234C148.928 136.234 149.128 136.036 149.128 135.793V135.623Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.252 135.623C152.252 135.38 152.052 135.182 151.806 135.182C151.56 135.182 151.359 135.38 151.359 135.623V135.793C151.359 136.036 151.56 136.234 151.806 136.234C152.052 136.234 152.252 136.036 152.252 135.793V135.623Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.378 135.623C155.378 135.38 155.178 135.182 154.932 135.182C154.686 135.182 154.485 135.38 154.485 135.623V135.793C154.485 136.036 154.686 136.234 154.932 136.234C155.178 136.234 155.378 136.036 155.378 135.793V135.623Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.502 135.623C158.502 135.38 158.302 135.182 158.056 135.182C157.81 135.182 157.609 135.38 157.609 135.623V135.793C157.609 136.036 157.81 136.234 158.056 136.234C158.302 136.234 158.502 136.036 158.502 135.793V135.623Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.564 137.727C147.564 137.484 147.364 137.286 147.117 137.286C146.871 137.286 146.671 137.484 146.671 137.727V137.897C146.671 138.14 146.871 138.338 147.117 138.338C147.364 138.338 147.564 138.14 147.564 137.897V137.727Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.69 137.727C150.69 137.484 150.49 137.286 150.243 137.286C149.997 137.286 149.797 137.484 149.797 137.727V137.897C149.797 138.14 149.997 138.338 150.243 138.338C150.49 138.338 150.69 138.14 150.69 137.897V137.727Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.816 137.727C153.816 137.484 153.615 137.286 153.369 137.286C153.123 137.286 152.923 137.484 152.923 137.727V137.897C152.923 138.14 153.123 138.338 153.369 138.338C153.615 138.338 153.816 138.14 153.816 137.897V137.727Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.941 137.727C156.941 137.484 156.74 137.286 156.494 137.286C156.248 137.286 156.048 137.484 156.048 137.727V137.897C156.048 138.14 156.248 138.338 156.494 138.338C156.74 138.338 156.941 138.14 156.941 137.897V137.727Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.066 137.727C160.066 137.484 159.865 137.286 159.619 137.286C159.373 137.286 159.173 137.484 159.173 137.727V137.897C159.173 138.14 159.373 138.338 159.619 138.338C159.865 138.338 160.066 138.14 160.066 137.897V137.727Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.002 139.831C146.002 139.588 145.802 139.39 145.556 139.39C145.31 139.39 145.109 139.588 145.109 139.831V140.001C145.109 140.244 145.31 140.442 145.556 140.442C145.802 140.442 146.002 140.244 146.002 140.001V139.831Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.128 139.831C149.128 139.588 148.928 139.39 148.682 139.39C148.436 139.39 148.235 139.588 148.235 139.831V140.001C148.235 140.244 148.436 140.442 148.682 140.442C148.928 140.442 149.128 140.244 149.128 140.001V139.831Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.252 139.831C152.252 139.588 152.052 139.39 151.806 139.39C151.56 139.39 151.359 139.588 151.359 139.831V140.001C151.359 140.244 151.56 140.442 151.806 140.442C152.052 140.442 152.252 140.244 152.252 140.001V139.831Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.378 139.831C155.378 139.588 155.178 139.39 154.932 139.39C154.686 139.39 154.485 139.588 154.485 139.831V140.001C154.485 140.244 154.686 140.442 154.932 140.442C155.178 140.442 155.378 140.244 155.378 140.001V139.831Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.502 139.831C158.502 139.588 158.302 139.39 158.056 139.39C157.81 139.39 157.609 139.588 157.609 139.831V140.001C157.609 140.244 157.81 140.442 158.056 140.442C158.302 140.442 158.502 140.244 158.502 140.001V139.831Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.564 141.935C147.564 141.692 147.364 141.494 147.117 141.494C146.871 141.494 146.671 141.692 146.671 141.935V142.105C146.671 142.348 146.871 142.546 147.117 142.546C147.364 142.546 147.564 142.348 147.564 142.105V141.935Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.69 141.935C150.69 141.692 150.49 141.494 150.243 141.494C149.997 141.494 149.797 141.692 149.797 141.935V142.105C149.797 142.348 149.997 142.546 150.243 142.546C150.49 142.546 150.69 142.348 150.69 142.105V141.935Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.816 141.935C153.816 141.692 153.615 141.494 153.369 141.494C153.123 141.494 152.923 141.692 152.923 141.935V142.105C152.923 142.348 153.123 142.546 153.369 142.546C153.615 142.546 153.816 142.348 153.816 142.105V141.935Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.941 141.935C156.941 141.692 156.74 141.494 156.494 141.494C156.248 141.494 156.048 141.692 156.048 141.935V142.105C156.048 142.348 156.248 142.546 156.494 142.546C156.74 142.546 156.941 142.348 156.941 142.105V141.935Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.066 141.935C160.066 141.692 159.865 141.494 159.619 141.494C159.373 141.494 159.173 141.692 159.173 141.935V142.105C159.173 142.348 159.373 142.546 159.619 142.546C159.865 142.546 160.066 142.348 160.066 142.105V141.935Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.002 144.04C146.002 143.796 145.802 143.598 145.556 143.598C145.31 143.598 145.109 143.796 145.109 144.04V144.209C145.109 144.453 145.31 144.65 145.556 144.65C145.802 144.65 146.002 144.453 146.002 144.209V144.04Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.128 144.04C149.128 143.796 148.928 143.598 148.682 143.598C148.436 143.598 148.235 143.796 148.235 144.04V144.209C148.235 144.453 148.436 144.65 148.682 144.65C148.928 144.65 149.128 144.453 149.128 144.209V144.04Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.252 144.04C152.252 143.796 152.052 143.598 151.806 143.598C151.56 143.598 151.359 143.796 151.359 144.04V144.209C151.359 144.453 151.56 144.65 151.806 144.65C152.052 144.65 152.252 144.453 152.252 144.209V144.04Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.378 144.04C155.378 143.796 155.178 143.598 154.932 143.598C154.686 143.598 154.485 143.796 154.485 144.04V144.209C154.485 144.453 154.686 144.65 154.932 144.65C155.178 144.65 155.378 144.453 155.378 144.209V144.04Z",
    fill: "#FECCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.502 144.04C158.502 143.796 158.302 143.598 158.056 143.598C157.81 143.598 157.609 143.796 157.609 144.04V144.209C157.609 144.453 157.81 144.65 158.056 144.65C158.302 144.65 158.502 144.453 158.502 144.209V144.04Z",
    fill: "#FECCFF"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M145.354 148.246V154.898C145.354 157.545 147.526 159.691 150.207 159.691C152.888 159.691 155.059 157.545 155.059 154.898V148.246H145.356H145.354Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M147.861 149.711V154.397C147.861 155.645 148.833 156.719 150.094 156.778C151.441 156.84 152.553 155.78 152.553 154.463V149.711C152.553 149.181 152.12 148.753 151.584 148.753H148.831C148.294 148.753 147.861 149.181 147.861 149.711Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M159.749 145.416H145.354V148.246H159.749V145.416Z",
    fill: "#28282A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M145.354 145.416H154.882C155.578 145.416 156.145 145.976 156.145 146.664V146.998C156.145 147.686 155.58 148.246 154.882 148.246H145.354V145.416Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M148.335 145.755H152.082C152.343 145.755 152.555 145.965 152.555 146.223V147.441C152.555 147.699 152.343 147.909 152.082 147.909H148.335C148.073 147.909 147.861 147.699 147.861 147.441V146.223C147.861 145.965 148.073 145.755 148.335 145.755Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M153.301 167.638H152.212H151.124V181.02H152.212H153.301H154.389V167.638H153.301Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M151.124 168.162V169.965C151.124 170.254 151.362 170.489 151.654 170.489H151.681C151.974 170.489 152.212 170.254 152.212 169.965V168.162C152.212 167.873 151.974 167.638 151.681 167.638H151.654C151.362 167.638 151.124 167.873 151.124 168.162Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M151.124 173.687V180.495C151.124 180.785 151.362 181.02 151.654 181.02H151.681C151.974 181.02 152.212 180.785 152.212 180.495V173.687C152.212 173.397 151.974 173.163 151.681 173.163H151.654C151.362 173.163 151.124 173.397 151.124 173.687Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M152.212 171.826C152.212 172.086 151.998 172.299 151.733 172.299H151.601C151.338 172.299 151.122 172.088 151.122 171.826C151.122 171.566 151.336 171.353 151.601 171.353H151.733C151.996 171.353 152.212 171.564 152.212 171.826Z",
    fill: "#E6E6E7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M165.829 182.471C161.921 183.043 157.483 183.365 152.778 183.365C148.073 183.365 143.634 183.043 139.727 182.471C139.158 182.388 139.066 181.614 139.601 181.4L150.927 176.89C150.95 176.881 150.975 176.872 150.998 176.864C151.271 176.758 151.551 176.679 151.835 176.626C152.457 176.508 153.099 176.508 153.721 176.626C154.003 176.679 154.283 176.758 154.556 176.864H154.558C154.581 176.872 154.606 176.881 154.629 176.89L165.955 181.4C166.489 181.614 166.398 182.388 165.829 182.471Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M154.558 176.864L161.303 181.161C161.626 181.365 161.504 181.859 161.122 181.891C160.714 181.927 160.302 181.961 159.888 181.991C159.582 182.011 159.283 181.904 159.063 181.695L153.721 176.626L154.558 176.864Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M153.137 176.544C153.017 176.544 152.899 176.544 152.778 176.544C152.658 176.544 152.538 176.544 152.42 176.544L150.178 181.614C150.054 181.895 150.256 182.213 150.567 182.219C151.298 182.234 152.034 182.243 152.78 182.243C153.526 182.243 154.223 182.236 154.934 182.221C155.272 182.213 155.495 181.866 155.358 181.561L153.139 176.544H153.137Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M151.835 176.626L146.527 181.664C146.285 181.893 145.957 182.011 145.623 181.987C145.081 181.947 144.545 181.902 144.016 181.855C143.772 181.832 143.694 181.517 143.9 181.385L150.998 176.864C151.271 176.758 151.551 176.679 151.835 176.626Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M152.756 168.196C146.846 168.196 142.038 163.445 142.038 157.606V147.064H143.755V157.606C143.755 162.51 147.793 166.5 152.756 166.5C157.719 166.5 161.756 162.51 161.756 157.606V147.064H163.474V157.606C163.474 163.445 158.665 168.196 152.756 168.196Z",
    fill: "#F4A428"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.106 164.239C159.14 166.65 156.127 168.195 152.758 168.195C146.847 168.195 142.04 163.445 142.04 157.606V147.064H143.757V157.606C143.757 161.988 146.984 165.642 151.214 166.366C151.218 166.366 151.222 166.368 151.226 166.368C151.724 166.454 152.235 166.498 152.758 166.498C153.158 166.498 153.553 166.471 153.941 166.42C155.887 166.294 158.492 165.781 161.106 164.239Z",
    fill: "black"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M163.193 145.063H162.039C161.627 145.063 161.293 145.393 161.293 145.801V148.329C161.293 148.736 161.627 149.066 162.039 149.066H163.193C163.605 149.066 163.939 148.736 163.939 148.329V145.801C163.939 145.393 163.605 145.063 163.193 145.063Z",
    fill: "#4CC9F0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M163.193 145.063H162.039C161.627 145.063 161.293 145.393 161.293 145.801V148.329C161.293 148.736 161.627 149.066 162.039 149.066H163.193C163.605 149.066 163.939 148.736 163.939 148.329V145.801C163.939 145.393 163.605 145.063 163.193 145.063Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M162.489 145.063H162.039C161.627 145.063 161.293 145.393 161.293 145.801V147.266C161.293 147.673 161.627 148.003 162.039 148.003H162.489C162.901 148.003 163.235 147.673 163.235 147.266V145.801C163.235 145.393 162.901 145.063 162.489 145.063Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M162.039 146.536C161.627 146.536 161.293 146.206 161.293 145.799C161.293 145.391 161.627 145.062 162.039 145.062C162.451 145.062 162.785 145.391 162.785 145.799C162.785 146.206 162.451 146.536 162.039 146.536Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.038 147.064V157.606C142.038 160.115 142.925 162.423 144.408 164.239C147.022 165.781 149.627 166.294 151.573 166.42C147.167 165.847 143.755 162.112 143.755 157.606V147.064H142.038Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M143.36 145.063H142.206C141.794 145.063 141.46 145.393 141.46 145.801V148.329C141.46 148.736 141.794 149.066 142.206 149.066H143.36C143.772 149.066 144.106 148.736 144.106 148.329V145.801C144.106 145.393 143.772 145.063 143.36 145.063Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.656 145.063H142.206C141.794 145.063 141.46 145.393 141.46 145.801V147.266C141.46 147.673 141.794 148.003 142.206 148.003H142.656C143.068 148.003 143.402 147.673 143.402 147.266V145.801C143.402 145.393 143.068 145.063 142.656 145.063Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.203 146.536C141.791 146.536 141.457 146.206 141.457 145.799C141.457 145.391 141.791 145.062 142.203 145.062C142.615 145.062 142.949 145.391 142.949 145.799C142.949 146.206 142.615 146.536 142.203 146.536Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M140.849 127.551C141.908 128.632 143.545 128.897 144.913 128.239C147.313 127.084 150.007 126.433 152.858 126.433C155.709 126.433 158.403 127.082 160.803 128.239C162.171 128.899 163.811 128.634 164.868 127.551C161.534 124.648 157.373 122.821 152.858 122.821C148.344 122.821 144.18 124.648 140.849 127.551Z",
    fill: "#6D7081"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.402 126.322C143.453 127.163 144.915 127.329 146.155 126.731C148.556 125.575 151.25 124.925 154.101 124.925C156.951 124.925 159.645 125.573 162.046 126.731C162.746 127.068 163.519 127.163 164.246 127.029C161.023 124.431 157.098 122.82 152.86 122.82C149.021 122.82 145.438 124.142 142.402 126.322Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M171.01 141.83C171.01 131.925 162.883 123.895 152.86 123.895C142.837 123.895 134.711 131.925 134.711 141.83H133.039C133.039 131.013 141.914 122.244 152.86 122.244C163.807 122.244 172.681 131.013 172.681 141.83H171.01Z",
    fill: "#6D7081"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M132.814 142.128C132.068 142.692 131.389 143.369 130.809 144.159C127.588 148.539 128.571 154.67 133.003 157.853C133.803 158.426 134.659 158.863 135.547 159.171L132.814 142.126V142.128Z",
    fill: "#FAD930"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M132.814 142.128C132.068 142.692 131.389 143.369 130.809 144.159C127.588 148.539 128.571 154.67 133.003 157.853C133.803 158.426 134.659 158.863 135.547 159.171L132.814 142.126V142.128Z",
    fill: "#6D7081"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M130.807 144.158C129.88 145.42 129.304 146.826 129.056 148.265C129.475 150.703 130.819 152.986 133.003 154.553C133.631 155.004 134.297 155.37 134.982 155.656L132.815 142.128C132.069 142.692 131.389 143.368 130.809 144.158H130.807Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M138.283 141.104C138.898 146.966 139.819 152.713 141.067 158.475C141.323 159.601 140.571 160.487 139.438 160.755C138.304 161.022 137.217 160.549 136.953 159.39C135.667 153.452 134.717 147.53 134.085 141.491C133.975 140.308 134.862 139.526 136.022 139.434C137.182 139.343 138.176 139.956 138.285 141.104H138.283Z",
    fill: "#6D7081"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M138.897 155.519C137.849 150.686 137.076 145.863 136.561 140.948C136.493 140.209 135.985 139.735 135.313 139.588C134.523 139.884 133.995 140.563 134.083 141.491C134.646 146.866 135.462 152.147 136.54 157.431C136.844 157.512 137.183 157.512 137.529 157.431C138.479 157.206 139.11 156.461 138.895 155.519H138.897Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M132.759 141.781L135.602 159.515C135.638 159.744 135.855 159.899 136.086 159.863L136.72 159.764C136.951 159.728 137.108 159.514 137.072 159.285L134.229 141.551C134.193 141.322 133.976 141.167 133.745 141.203L133.111 141.302C132.88 141.338 132.723 141.553 132.759 141.781Z",
    fill: "#6D7081"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M135.817 159.093L133.063 141.919C133.038 141.764 133.145 141.619 133.302 141.594C133.458 141.57 133.605 141.675 133.63 141.83L136.383 159.005C136.408 159.159 136.301 159.305 136.145 159.329C135.988 159.354 135.841 159.248 135.817 159.093Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M131.813 147.865C131.981 148.699 131.765 149.445 131.332 149.53C130.899 149.615 130.41 149.008 130.242 148.175C130.075 147.341 130.29 146.594 130.723 146.51C131.156 146.425 131.645 147.032 131.813 147.865Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M172.797 142.164C173.543 142.728 174.222 143.404 174.802 144.194C178.023 148.574 177.04 154.706 172.608 157.889C171.808 158.462 170.952 158.899 170.064 159.207L172.797 142.162V142.164Z",
    fill: "#FAD930"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M172.797 142.164C173.543 142.728 174.222 143.404 174.802 144.194C178.023 148.574 177.04 154.706 172.608 157.889C171.808 158.462 170.952 158.899 170.064 159.207L172.797 142.162V142.164Z",
    fill: "#6D7081"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M174.803 144.194C175.73 145.456 176.306 146.862 176.554 148.301C176.135 150.739 174.791 153.022 172.607 154.591C171.979 155.041 171.313 155.407 170.628 155.694L172.796 142.166C173.542 142.729 174.221 143.406 174.801 144.196L174.803 144.194Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M167.326 141.142C166.712 147.004 165.79 152.751 164.542 158.513C164.287 159.638 165.038 160.525 166.172 160.792C167.305 161.06 168.393 160.587 168.656 159.427C169.942 153.49 170.892 147.568 171.524 141.528C171.635 140.346 170.747 139.564 169.587 139.471C168.427 139.381 167.433 139.994 167.324 141.142H167.326Z",
    fill: "#6D7081"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M166.713 155.556C167.761 150.724 168.534 145.901 169.049 140.985C169.117 140.246 169.625 139.773 170.297 139.626C171.087 139.922 171.615 140.601 171.527 141.528C170.964 146.904 170.148 152.185 169.07 157.468C168.766 157.549 168.427 157.549 168.081 157.468C167.131 157.244 166.5 156.499 166.715 155.556H166.713Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M171.382 141.588L168.539 159.322C168.503 159.55 168.66 159.765 168.891 159.801L169.525 159.9C169.756 159.936 169.973 159.78 170.009 159.552L172.852 141.818C172.888 141.589 172.731 141.375 172.5 141.339L171.866 141.24C171.635 141.203 171.418 141.359 171.382 141.588Z",
    fill: "#6D7081"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M169.792 159.129L172.545 141.954C172.57 141.8 172.463 141.655 172.307 141.63C172.15 141.605 172.003 141.711 171.979 141.866L169.225 159.041C169.2 159.195 169.307 159.34 169.464 159.365C169.62 159.389 169.767 159.284 169.792 159.129Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.798 147.903C173.63 148.736 173.846 149.483 174.279 149.568C174.712 149.653 175.201 149.046 175.369 148.212C175.536 147.379 175.321 146.632 174.888 146.547C174.455 146.462 173.966 147.07 173.798 147.903Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8_6045",
    x: 24.1011,
    y: 28.8939,
    width: 258.517,
    height: 259.316,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.59125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.39625
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8_6045"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8_6045",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_8_6045",
    x: 47.0908,
    y: 44.6953,
    width: 212.537,
    height: 212.537,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.39625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.7925
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8_6045"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8_6045",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_8_6045",
    x: 81.8889,
    y: 86.6816,
    width: 142.942,
    height: 143.74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.59125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.39625
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8_6045"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8_6045",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_6045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.7861,
    height: 61.1217,
    fill: "white",
    transform: "translate(128.91 122.244)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIllustration);
export default __webpack_public_path__ + "static/media/contact-illustration.319f0c5d0d7a6e725650159f33dc9394.svg";
export { ForwardRef as ReactComponent };